import { Component, input, model, output } from '@angular/core';

@Component({
  selector: 'app-primeng-paginator',
  templateUrl: './primeng-paginator.component.html',
  styleUrls: ['./primeng-paginator.component.scss'],
  standalone: false,
})
export class PrimengPaginatorComponent {
  totalRecords = input<number>(0);
  rows = model<number>(10);
  first = model<number>(0);
  rowsPerPageOptions = input<number[]>([10, 25, 50]);
  showFirstLastIcon = input<boolean>(true);
  showCurrentPageReport = input<boolean>(false);
  currentPageReportTemplate = input<string>('{first} to {last} of {totalRecords}');
  showPageLinks = input<boolean>(true);
  showJumpToPageDropdown = input<boolean>(false);
  styleClass = input<string>('');
  alwaysShow = input<boolean>(true);

  onPageChange = output<any>();

  handlePageChange(event: any) {
    this.first.set(event.first);
    if (event.rows != null) {
      this.rows.set(event.rows);
    }
    this.onPageChange.emit(event);
  }
}
